// Brand kit boxes carry their asset in the box id: `bo-<ts>-brand<asset id
// without dashes>-<scene id>`. Dependency-free so reducers can use it too.

/** Id fragment marking a box as a copy of this brand asset. */
export const brandAssetTag = (assetId) => `brand${String(assetId).replace(/-/g, "")}`;

/** The brand tag carried in a box id, or null. */
export const brandTagOfBox = (boxId) => {
  const match = /-(brand[0-9a-f]{32})-/i.exec(String(boxId || ""));
  return match ? match[1] : null;
};

export const isBrandBoxId = (boxId) => brandTagOfBox(boxId) !== null;
